/**
 * The fixed list of countries a wine's Pays can be chosen from (FR-004),
 * with French names. ISO 3166-1 alpha-2 codes, so the same codes place a
 * wine on the User Story 10 world map without any extra mapping.
 *
 * This starting list covers the major wine-producing countries plus a
 * handful of others; it is meant to be extended, not exhaustive. Swapping
 * in a full ISO country library (research.md's original idea) is a
 * drop-in replacement as long as it keeps this same `{ code, name }` shape.
 */

export interface Country {
  /** ISO 3166-1 alpha-2 code. */
  code: string;
  /** French name. */
  name: string;
  /** ISO 3166-1 numeric code: how the bundled world map names countries (User Story 10). */
  numeric: string;
}

export const COUNTRIES: Country[] = [
  { code: 'FR', name: 'France', numeric: '250' },
  { code: 'IT', name: 'Italie', numeric: '380' },
  { code: 'ES', name: 'Espagne', numeric: '724' },
  { code: 'PT', name: 'Portugal', numeric: '620' },
  { code: 'DE', name: 'Allemagne', numeric: '276' },
  { code: 'CH', name: 'Suisse', numeric: '756' },
  { code: 'AT', name: 'Autriche', numeric: '040' },
  { code: 'GR', name: 'Grèce', numeric: '300' },
  { code: 'HU', name: 'Hongrie', numeric: '348' },
  { code: 'GB', name: 'Royaume-Uni', numeric: '826' },
  { code: 'US', name: 'États-Unis', numeric: '840' },
  { code: 'CA', name: 'Canada', numeric: '124' },
  { code: 'CL', name: 'Chili', numeric: '152' },
  { code: 'AR', name: 'Argentine', numeric: '032' },
  { code: 'ZA', name: 'Afrique du Sud', numeric: '710' },
  { code: 'AU', name: 'Australie', numeric: '036' },
  { code: 'NZ', name: 'Nouvelle-Zélande', numeric: '554' },
  { code: 'GE', name: 'Géorgie', numeric: '268' },
  { code: 'MA', name: 'Maroc', numeric: '504' },
  { code: 'LB', name: 'Liban', numeric: '422' },
  { code: 'IL', name: 'Israël', numeric: '376' },
  { code: 'HR', name: 'Croatie', numeric: '191' },
  { code: 'SI', name: 'Slovénie', numeric: '705' },
  { code: 'RO', name: 'Roumanie', numeric: '642' },
  { code: 'BG', name: 'Bulgarie', numeric: '100' },
  { code: 'MD', name: 'Moldavie', numeric: '498' },
  { code: 'JP', name: 'Japon', numeric: '392' },
  { code: 'CN', name: 'Chine', numeric: '156' },
  { code: 'UY', name: 'Uruguay', numeric: '858' },
  { code: 'BR', name: 'Brésil', numeric: '076' },
  { code: 'MX', name: 'Mexique', numeric: '484' },
  { code: 'LU', name: 'Luxembourg', numeric: '442' },
  { code: 'BE', name: 'Belgique', numeric: '056' },
  { code: 'NL', name: 'Pays-Bas', numeric: '528' },
];

const BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c] as const));

/** The French name for a country code, or the code itself if not in the list. */
export function countryName(code: string): string {
  return BY_CODE.get(code)?.name ?? code;
}
